(ns rothko.form2.checkbox.component
  (:require [rothko.form2.component :as form]
            [rothko.form2.label.component :as label]
            [rothko.form2.validation-message.component :as validation-message]))

(defn tooltip*
      [tooltip & content]
  `[:div.tooltip {:style {:justify-content :left :width :fit-content}}
    ~@content
    [~(fn [_] [:div.tooltip__tip.side-tip.plain-black.leftward-triangle tooltip])]])


;; TODO rothko#210 use defcomp for input and assert props there
(defn field*
  [{:keys [::form/name
           ::form/set-value!
           ::option]}]
  (assert (not (nil? option)))
  (fn [{:keys [appearance
               tab-index
               tooltip
               ::form/disabled?
               ::form/description
               ::form/value
               ::label]
        :as field-props}]
    ;; TODO rothko#254
    [:div.checkbox.tab-item
     {:tab-index tab-index}

     (cond->> [[:input
                {:type :checkbox
                 :name name
                 ;; Note that we do not set the DOM value attribute and as such
                 ;; nor do we use the value in the on change event.
                 :on-change #(set-value! (when (nil? value) option))
                 :disabled disabled?
                 :defaultChecked value}]
               [:label {:for name} label]]
              tooltip (into [tooltip* tooltip])
              tooltip (vector)
              true (into [:div.checkbox__container
                          {:class appearance}
                          [label/component field-props]
                          (when description
                            [:p description])]))

     [validation-message/component field-props]]))

(defn field
  [{:keys [::option] :as field-props}]
  (let [field-props (update field-props ::label #(or % option))]
    [field* field-props]))
